export const PROCESS_RTK_TAGS = {
  TAGS: 'PROCESS',
  HASHID: 'PROCESSHASHID',
};

export const useProcessById = () => ({});

export const useProcessVersionDetail = () => ({});
export const useApproveProcessVersion = () => ({});
export const useProcesses = () => ({});
export const convertLocationParamsToFetchParams = () => ({});
export const useUpdateProcess = () => [() => ({}), {}];
